module.exports = __webpack_public_path__ + "img/8a5bd66.webp";